import { SEARCH } from "../constants/";

export const initialState = {
  showSearch: false,
  isSearching: false,
  searchComplete: false,
  error: false,
  showAdvanced: false,
  noAddressWarning: false,
  currentSearch: {
    lat: "",
    lng: "",
    date: "",
    currentDate: "",
    formattedAddress: "",
    previousDate: "",
    nextDate: ""
  },
  boundary: [],
  crimes: [],
  crimesByCategory: [],
  stopAndSearches: [],
  categories: {},
  selectedIncident: {},
  selectedIncidents: [],
  availability: [],
  availabilityError: false
};

const setState = (state, newState) => Object.assign({}, state, newState);
export const crimesByCategory = (crimes, categories) => {
  let categoryStats = {};
  crimes.forEach(crime => {
    if (!categoryStats[crime.category]) {
      categoryStats[crime.category] = 1;
    } else {
      categoryStats[crime.category]++;
    }
  });
  const sortedStats = Object.keys(categoryStats)
    .map(name => {
      return {
        name,
        value: categoryStats[name]
      };
    })
    .sort((a, b) => b.value - a.value);
  return sortedStats;
};

const search = (state = initialState, action = {}) => {
  switch (action.type) {
    case SEARCH.res_crime_by_location: {
      const date = state.currentSearch.date;
      const datesArray = state.availability.map(d => d.date);
      const categories = state.categories[date];
      return setState(state, {
        isSearching: false,
        searchComplete: true,
        crimes: action.crimes,
        selectedIncident: {},
        selectedIncidents: [],
        crimesByCategory: crimesByCategory(action.crimes, categories),
        currentSearch: {
          ...state.currentSearch,
          currentDate: date,
          previousDate: datesArray[datesArray.indexOf(date) + 1],
          nextDate: datesArray[datesArray.indexOf(date) - 1]
        }
      });
    }
    case SEARCH.err_crime_by_location: {
      return setState(state, {
        isSearching: false,
        error: true
      });
    }
    case SEARCH.req_coords: {
      return setState(state, {
        isSearching: true,
        showSearch: false,
        searchComplete: false,
        error: false,
        noAddressWarning: false
      });
    }
    case SEARCH.res_coords: {
      return setState(state, {
        currentSearch: {
          ...state.currentSearch,
          ...action.criteria
        }
      });
    }
    case SEARCH.res_boundary: {
      return setState(state, {
        boundary: action.boundary
      });
    }
    case SEARCH.res_categories: {
      return setState(state, {
        categories: {
          ...state.categories,
          [action.date]: action.categories.reduce((prev, current) => {
            return Object.assign({}, prev, {
              [current.url]: current.name
            });
          }, {})
        }
      });
    }
    case SEARCH.res_availability: {
      const date = state.currentSearch.date || action.dates[0].date;
      const datesArray = action.dates.map(d => d.date);
      return setState(state, {
        currentSearch: {
          ...state.currentSearch,
          date,
          previousDate: datesArray[datesArray.indexOf(date) + 1],
          nextDate: datesArray[datesArray.indexOf(date) - 1]
        },
        availability: action.dates,
        availabilityError: false
      });
    }
    case SEARCH.err_availability: {
      return setState(state, {
        availabilityError: true
      });
    }
    case SEARCH.toggle_advanced: {
      return setState(state, {
        showAdvanced: !state.showAdvanced
      });
    }
    case SEARCH.change_date: {
      return setState(state, {
        currentSearch: {
          ...state.currentSearch,
          date: action.date
        }
      });
    }
    case SEARCH.no_address: {
      return setState(state, {
        noAddressWarning: true
      });
    }
    case SEARCH.show_search: {
      return {
        ...state,
        showSearch: true
      };
    }
    case SEARCH.select_incidents: {
      const { selectedIncidents } = action;
      return {
        ...state,
        selectedIncidents
      };
    }
    default: {
      return state;
    }
  }
};

export default search;



// WEBPACK FOOTER //
// ./src/reducers/search.js